import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addTestCenter } from "../../actions/testcenterActions";

class CreateTCForm extends Component {
  state = {
    name: "",
    address: "",
    coordUrl: "",
    appointment: false,
    registLink: "",
    registPhone: "",
    getResults: "",
    resultsTime: "",
    resultLink: "",
    resultPhone: "",
    walkThru: false,
    driveThru: false,
    noseSwab: false,
    saliva: false,
    schedule: [],
    daysOfWeek1: "",
    timesOfDay1: "",
    daysOfWeek2: "",
    timesOfDay2: "",
    daysOfWeek3: "",
    timesOfDay3: "",
    errors: {},
  };

  onChange = (e) => this.setState({ [e.target.id]: e.target.value });

  onSubmit = (e) => {
    e.preventDefault();

    const {
      name,
      address,
      coordUrl,
      appointment,
      registLink,
      registPhone,
      getResults,
      resultsTime,
      resultLink,
      resultPhone,
      walkThru,
      driveThru,
      noseSwab,
      saliva,
      schedule,
      daysOfWeek1,
      daysOfWeek2,
      daysOfWeek3,
      timesOfDay1,
      timesOfDay2,
      timesOfDay3,
    } = this.state;

    // Check For Errors
    if (name === "") {
      this.setState({ errors: { name: "Name is Required" } });
      return;
    }
    if (address === "") {
      this.setState({ errors: { address: "Address is Required" } });
      return;
    }
    if (coordUrl === "") {
      this.setState({ errors: { coordUrl: "Google Maps URL is Required" } });
      return;
    }
    if (getResults === "") {
      this.setState({ errors: { getResults: "Get Results is Required" } });
      return;
    }
    if (resultsTime === "") {
      this.setState({ errors: { resultsTime: "Results Time is Required" } });
      return;
    }

    // Create Schedule
    if (daysOfWeek1 !== "" && timesOfDay1 !== "") {
      schedule.push({
        daysOfWeek: daysOfWeek1,
        timesOfDay: timesOfDay1,
      });
    }
    if (daysOfWeek2 !== "" && timesOfDay2 !== "") {
      schedule.push({
        daysOfWeek: daysOfWeek2,
        timesOfDay: timesOfDay2,
      });
    }
    if (daysOfWeek3 !== "" && timesOfDay3 !== "") {
      schedule.push({
        daysOfWeek: daysOfWeek3,
        timesOfDay: timesOfDay3,
      });
    }

    const newTestCenter = {
      name,
      address,
      coordUrl,
      appointment,
      registLink,
      registPhone,
      getResults,
      resultsTime,
      resultLink,
      resultPhone,
      walkThru,
      driveThru,
      noseSwab,
      saliva,
      schedule,
    };

    this.props.addTestCenter(newTestCenter);

    // Clear State
    this.setState({
      name: "",
      address: "",
      coordUrl: "",
      appointment: false,
      registLink: "",
      registPhone: "",
      getResults: "",
      resultsTime: "",
      resultLink: "",
      resultPhone: "",
      walkThru: false,
      driveThru: false,
      noseSwab: false,
      saliva: false,
      schedule: [],
      daysOfWeek1: "",
      timesOfDay1: "",
      daysOfWeek2: "",
      timesOfDay2: "",
      daysOfWeek3: "",
      timesOfDay3: "",
      errors: {},
    });

    window.location.replace("/admin/testcenters");
  };

  render() {
    const {
      name,
      address,
      coordUrl,
      appointment,
      registLink,
      registPhone,
      getResults,
      resultsTime,
      resultLink,
      resultPhone,
      walkThru,
      driveThru,
      noseSwab,
      saliva,
      daysOfWeek1,
      daysOfWeek2,
      daysOfWeek3,
      timesOfDay1,
      timesOfDay2,
      timesOfDay3,
      errors,
    } = this.state;

    return (
      <>
        <div className="row">
          <div className="col-md-6 col-lg-9">
            <h3 className="mb-4">New Test Center</h3>
          </div>
          <div className="col-md-6 col-lg-3">
            <button
              className="btn btn-primary btn mb-4 float-md-right"
              style={{ fontWeight: "500" }}
            >
              <Link to="/admin/testcenters" className="text-white">
                Go Back
              </Link>
            </button>
          </div>
        </div>
        <form onSubmit={this.onSubmit}>
          <div className="form-group">
            <label htmlFor="name">Site Name</label>
            <input
              type="text"
              id="name"
              placeholder="Enter Site Name"
              className="form-control"
              required
              value={name}
              onChange={this.onChange}
              error={errors.name}
            />
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label htmlFor="address">Site Address</label>
              <input
                type="text"
                id="address"
                placeholder="Enter Site Address"
                className="form-control"
                required
                value={address}
                onChange={this.onChange}
                error={errors.address}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="coordUrl">Google Maps URL</label>
              <input
                type="text"
                id="coordUrl"
                placeholder="Enter Google Maps URL"
                required
                className="form-control"
                value={coordUrl}
                onChange={this.onChange}
                error={errors.coordUrl}
              />
            </div>
          </div>
          <div className="form-row">
            <h5 className="col-md-12 my-4">Test Center Registration</h5>
            <div className="form-group col-md-4">
              <label htmlFor="appointment">Appointment Required</label>
              <select
                id="appointment"
                className="form-control"
                value={appointment}
                onChange={this.onChange}
                error={errors.appointment}
              >
                <option value={false} disabled>
                  Choose...
                </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
            <div className="form-group col-md-4">
              <label htmlFor="registLink">Registration Link</label>
              <input
                type="text"
                id="registLink"
                placeholder="Enter Registration Link "
                className="form-control"
                value={registLink}
                onChange={this.onChange}
                error={errors.registLink}
              />
            </div>
            <div className="form-group col-md-4">
              <label htmlFor="registPhone">Registration Phone</label>
              <input
                type="text"
                id="registPhone"
                placeholder="Enter Registration Phone "
                className="form-control"
                value={registPhone}
                onChange={this.onChange}
                error={errors.registPhone}
              />
            </div>
          </div>
          <div className="form-row">
            <h5 className="col-md-12 my-4">Test Center Results</h5>
            <div className="form-group col-md-3">
              <label htmlFor="getResults">Get Results</label>
              <select
                id="getResults"
                className="form-control"
                value={getResults}
                required
                onChange={this.onChange}
                error={errors.getResults}
              >
                <option value="" disabled>
                  Choose...
                </option>
                <option value="Patient Portal">Patient Portal</option>
                <option value="Phone Call">Phone Call</option>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label htmlFor="resultsTime">Results Time</label>
              <input
                type="text"
                id="resultsTime"
                placeholder="Enter Results Time "
                className="form-control"
                value={resultsTime}
                onChange={this.onChange}
                required
                error={errors.resultsTime}
              />
            </div>
            <div className="form-group col-md-3">
              <label htmlFor="resultLink">Results Link</label>
              <input
                type="text"
                id="resultLink"
                placeholder="Enter Results Link "
                className="form-control"
                value={resultLink}
                onChange={this.onChange}
                error={errors.resultLink}
              />
            </div>
            <div className="form-group col-md-3">
              <label htmlFor="resultPhone">Results Phone</label>
              <input
                type="text"
                id="resultPhone"
                placeholder="Enter Results Phone "
                className="form-control"
                value={resultPhone}
                onChange={this.onChange}
                error={errors.resultPhone}
              />
            </div>
          </div>
          <div className="form-row">
            <h5 className="col-md-12 my-4">Test Center Specifications</h5>
            <div className="form-group col-md-3">
              <label htmlFor="walkThru">Walk-Thru Site</label>
              <select
                id="walkThru"
                value={walkThru}
                onChange={this.onChange}
                error={errors.walkThru}
                className="form-control"
              >
                <option value={false} disabled>
                  Choose...
                </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label htmlFor="driveThru">Drive-Thru Site</label>
              <select
                id="driveThru"
                value={driveThru}
                onChange={this.onChange}
                error={errors.driveThru}
                className="form-control"
              >
                <option value={false} disabled>
                  Choose...
                </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label htmlFor="noseSwab">Nose Swab Test</label>
              <select
                id="noseSwab"
                value={noseSwab}
                onChange={this.onChange}
                error={errors.noseSwab}
                className="form-control"
              >
                <option value={false} disabled>
                  Choose...
                </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label htmlFor="saliva">Saliva Test</label>
              <select
                id="saliva"
                value={saliva}
                onChange={this.onChange}
                error={errors.saliva}
                className="form-control"
              >
                <option value={false} disabled>
                  Choose...
                </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <h5 className="col-md-12 my-4">Test Center Schedule</h5>
            <div className="form-group col-md-4">
              <label htmlFor="daysOfWeek1">Days of Week</label>
              <input
                type="text"
                id="daysOfWeek1"
                placeholder="Enter Days of Week "
                value={daysOfWeek1}
                onChange={this.onChange}
                error={errors.daysOfWeek1}
                className="form-control"
              />
            </div>
            <div className="form-group col-md-4">
              <label htmlFor="timesOfDay1">Times of Day</label>
              <input
                type="text"
                id="timesOfDay1"
                placeholder="Enter Times of Day "
                value={timesOfDay1}
                onChange={this.onChange}
                error={errors.timesOfDay1}
                className="form-control"
              />
            </div>
            <div className="col-md-4"></div>
            <div className="form-group col-md-4">
              <input
                type="text"
                id="daysOfWeek2"
                placeholder="Enter Days of Week "
                value={daysOfWeek2}
                onChange={this.onChange}
                error={errors.daysOfWeek2}
                className="form-control"
              />
            </div>
            <div className="form-group col-md-4">
              <input
                type="text"
                id="timesOfDay2"
                placeholder="Enter Times of Day "
                value={timesOfDay2}
                onChange={this.onChange}
                error={errors.timesOfDay2}
                className="form-control"
              />
            </div>
            <div className="col-md-4"></div>
            <div className="form-group col-md-4">
              <input
                type="text"
                id="daysOfWeek3"
                placeholder="Enter Days of Week "
                className="form-control"
                value={daysOfWeek3}
                onChange={this.onChange}
                error={errors.daysOfWeek3}
              />
            </div>
            <div className="form-group col-md-4">
              <input
                type="text"
                id="timesOfDay3"
                placeholder="Enter Times of Day "
                value={timesOfDay3}
                onChange={this.onChange}
                error={errors.timesOfDay3}
                className="form-control"
              />
            </div>
            <div className="col-md-4"></div>
          </div>
          <div className="form-row">
            <div className="col-md-3"></div>
            <div className="col-md-6 my-4">
              <input
                type="submit"
                value="Create Test Center"
                style={{ fontWeight: "500" }}
                className="btn btn-success btn-block"
              />
            </div>
          </div>
        </form>
      </>
    );
  }
}

CreateTCForm.propTypes = {
  addTestCenter: PropTypes.func.isRequired,
};

export default connect(null, { addTestCenter })(CreateTCForm);
